<template>
  <module-list-layout :createAction="createAction" :module="module" class="" v-if="amReady">

    <el-dialog :append-to-body="true" :visible.sync="uploadVendorRateDialogVisibility" style="z-index: 2" title=""
               top="5vh"
               width="97%">
      <uploadDocumentRate :afterUploadCallback="afterUploadCallback" :editMode="false"
                          :targetVendorId="targetVendorId" v-if="uploadVendorRateDialogVisibility"></uploadDocumentRate>
    </el-dialog>

    <el-dialog :visible.sync="vendorRatesDialogVisible" @close="refreshGrid" title="" top="5vh" width="97%">
      <showVendorRates :editMode="false" :targetVendorId="targetVendorId"
                       v-if="vendorRatesDialogVisible"></showVendorRates>
    </el-dialog>

    <el-dialog
        :visible.sync="deleteConfirmDialogVisible"
        title="Confirm Delete" width="300">
      <div slot="title" style="font-size: 21px">
        Confirm Delete
      </div>
      <!--<div class="w-100 el-icon-warning-outline" style="font-size: 42px;" align="center">
      </div>-->
      <p class="ml-3 text-danger">
        Are you sure you want to delete this vendor ? <br>
        all details related will be removed as will such as rates and calls history
      </p>

      <span class="dialog-footer" slot="footer">
        <el-button @click="deleteConfirmDialogVisible = false">Cancel</el-button>
        <el-button @click="removeAction" type="danger">Delete</el-button>
      </span>
    </el-dialog>

    <el-dialog :visible.sync="dialogVisible" title="" top="5vh" width="75%">
      <moduleForm
          :autoBind="false"
          :bindingForView="true"
          :dataToBind="dataToBind"
          :edit-mode="editMode"
          :formHeader="true"
          :on-create-callback="afterCreate"
          :on-edit-callback="afterEdit"
          :profilesList="profilesList"
          v-if="dialogVisible"></moduleForm>
    </el-dialog>

    <div class="pl-3 pr-3 m-0 mt-1">
      <div class="row m-0 mb-2">
        <!--<div class="d-inline-block ml-3">
          Only has Unconnected <input class="ml-1" type="checkbox" v-model="showOnlyHasUnconnected">
        </div>-->
        <div class="d-inline-block ml-3">
          View All <input class="ml-1" type="checkbox" v-model="listAllOption">
        </div>
        <div class="d-inline-block ml-3">
          <el-button @click="exportVendors" icon="el-icon-download" size="mini">Export Vendors</el-button>
        </div>
        <div class="ml-3">
          <vendorsListKeys></vendorsListKeys>
        </div>
      </div>
      <div class="row m-0">
        <div class="col-12 col-md-4 mt-1">
          <small>Search</small>
          <dg-text-field
              :field_span="19"
              :label_span="0"
              :liveUpdate="true"
              @amUpdated="userSearchUpdated"
              field_mark=""
              label=""
              placeholder="search name or prefix"></dg-text-field>
        </div>
        <div class="col-12 col-md-3 mb-1">
          <dg-select-field
              :field_span="22"
              :label_span="22"
              :options="filterOptions"
              :translateLabels="false"
              @amUpdated="filterOptionsUpdated"
              field_mark=""
              :translateLabel="false"
              label="Filter Profile"
              name="destination"
              placeholder="Filter By Profile"
              rules=""></dg-select-field>
        </div>
        <div class="col-12 col-md-5 mb-1 pt-3">
          <pagination
              v-if="!listAllOption"
              :currentPage="currentPage"
              :margin-pages="2"
              :navigateHandler="navigateToPage"
              :page-count="getPagesCount()"
              :page-range="4"
              paginateClass=""></pagination>
        </div>
      </div>
    </div>

    <el-table
        :data="rowData"
        
        :row-class-name="tableRowClassName"
        border
        cell-class-name="p-1"
        style="width: 100%">
      <el-table-column type="expand">
        <template slot-scope="props">
          <h6 class="app-light-silver-background m-0 p-2 pl-3 text-center">CDR Account</h6>
          <el-table
              :data="[props.row]"
              border
              cell-class-name="p-1"
              header-cell-class-name="app-light-silver-background p-1"
              style="width: 100%;">
            <el-table-column
                label="Url"
                prop="">
              <template slot-scope="scope">
                <smartInputView :customParams="{id: scope.row.id, scope: scope}"
                                :inputValue="scope.row.cdr_account_link"
                                :saveAction="updateDataTableField"
                                editContainerStyle="position: relative;top: 0px;"
                                fieldName="cdr_account_link"
                                inputWidth="200px" linkText=""
                                viewMode="link"></smartInputView>
              </template>
            </el-table-column>
            <el-table-column
                label="Username"
                prop="">
              <template slot-scope="scope">
                <smartInputView :customParams="{id: scope.row.id, scope: scope}"
                                :inputValue="scope.row.cdr_account_username"
                                :saveAction="updateDataTableField"
                                editContainerStyle="position: relative;top: 0px;" fieldName="cdr_account_username"
                                inputWidth="200px"></smartInputView>
              </template>
            </el-table-column>
            <el-table-column
                label="Password"
                prop="password">
              <template slot-scope="scope">
                <smartInputView :customParams="{id: scope.row.id, scope: scope}"
                                :inputValue="scope.row.cdr_account_password"
                                :saveAction="updateDataTableField"
                                editContainerStyle="position: relative;top: 0px;" fieldName="cdr_account_password"
                                inputWidth="200px"></smartInputView>
              </template>
            </el-table-column>
          </el-table>

        </template>
      </el-table-column>
      <el-table-column
          label="Name"
          prop="name"
          sortable>
      </el-table-column>
      <el-table-column
          label="Division"
          width="120"
          prop="division_name"
          sortable>
      </el-table-column>
      <el-table-column
          label="Prefix"
          prop="prefix"
          width="90"
          sortable>
      </el-table-column>
      <el-table-column
          label="Assign" width="90">
        <template slot-scope="scope">
            
          <assignVendorModule :accManagerId="accManagerId" :data="scope.row" :actionsHandler="actionsHandler" ></assignVendorModule>
        </template>
      </el-table-column>
      <el-table-column
          label="Rates" width="90"
          sortable>
        <template slot-scope="scope">
          <vendorRatesCounterViewer :ratesCount="scope.row.current_rates_counter"
                                    :reqVendorId="scope.row.id"></vendorRatesCounterViewer>
        </template>
      </el-table-column>
      <!--
      <el-table-column
          label="Created"
          prop="created_at">
      </el-table-column>-->
      <el-table-column
          label="Working"
          prop="num_of_working_destinations"
          sortable>
      </el-table-column>
      <el-table-column
          label="FAS"
          prop="num_of_fas_destinations"
          sortable>
      </el-table-column>
      <el-table-column
          label="Uncon"
          prop="num_of_unconnected_destinations"
          sortable>
      </el-table-column>
      <!--<el-table-column
          label="Balance"
          width="190">
        <template slot-scope="scope">
          <popover title="Balance Info" :content=" 'Last Updated <br>' +  ((scope.row.last_balance_updated)? scope.row.last_balance_updated : '')" data="">
            <template v-slot:body>
              <smartInputView :customParams="{id: scope.row.id, scope: scope}"
                    :inputValue="scope.row.balance"
                    :saveAction="updateDataTableField"
                    editContainerStyle="position: relative;top: 0px;"
                    fieldName="balance"
                    :noCopy="true"
                    inputWidth="90px"></smartInputView>
            </template>
          </popover>
        </template>
      </el-table-column>-->
      <el-table-column
          label="Balance"
          width="130">
        <template slot-scope="scope">
          <smartInputView :customParams="{id: scope.row.id, scope: scope}"
                :inputValue="scope.row.balance"
                :saveAction="updateDataTableField"
                editContainerStyle="position: relative;top: 0px;"
                fieldName="balance"
                :noCopy="true"
                inputWidth="100px"></smartInputView>
        </template>
      </el-table-column>
      <el-table-column
          label="Balance Date"
          prop="last_balance_updated"
          width="190">
      </el-table-column>
      <el-table-column
          align="right"
          label="Actions" width="90">
        <template slot-scope="scope">
          <vDropdown :actionsHandler="actionsHandler" :items="usersActions"
                     :params="{data: scope.row, rowIndex: scope.$index + 1} "></vDropdown>
        </template>
      </el-table-column>
    </el-table>

  </module-list-layout>
</template>

<script>
import module from './../../index.js'
import {notify} from '@/system-services/notify.js'


export default {
  watch: {
    showOnlyHasUnconnected: function (val) {
      this.amReady = false
      $vue.nextTick(() => {
        this.getEntityListData(1);
        this.amReady = true
      })
    },
    listAllOption: function (val) {
      this.amReady = false
      $vue.nextTick(() => {
        this.getEntityListData(1);
        this.amReady = true
      })
    }
  },
  components: {
    // popover: () => import('@/components/popover/View'),
    vendorsListKeys: () => import('@/components/system-table-keys-info/VendorListing'),
    smartInputView: () => import('@/components/smart-input-view/View'),
    vendorRatesCounterViewer: () => import('@/modules/voip-vendor/list/page/ag-grid/VendorRatesCounterViewer'),
    assignVendorModule: () => import('@/modules/voip-vendor/list/page/ag-grid/assignVendorModule'),
    vDropdown: () => import('@/components/button-dropdown/View'),
    uploadDocumentRate: () => import('@/modules/voip-vendor/upload-document-rate/View.vue'),
    pagination: () => import('@/components/pagination/View.vue'),
    moduleForm: () => import('../../form/View'),
    moduleListLayout: () => import('@/modules-config/layouts/list/View.vue'),
    showVendorRates: () => import('@/modules/voip-vendor/view-rates/View')
  },
  data() {
    return {
      selectedFilterOption: '',
      filterOptions: [
            { label: 'None', value: ''},
            { label: 'Only Unconnected', value: 'only_unconnected'},
            { label: 'Valid Credentials', value: 'valid_credentials'},
            { label: 'Missing Credentials', value: 'missing_credentials'},
            { label: 'Portal Access Error', value: 'portal_access_error'},
      ],
      showOnlyMissingCredentials: 0,
      showOnlyHasUnconnected: 0,
      listAllOption: 0,
      rowData: [],
      usersActions: [
        {
          label: 'Edit',
          icon: 'el-icon-edit-outline',
          action: 'editAction',
          borderBottom: true
        },
        {
          label: 'View Rates',
          icon: 'el-icon-money',
          action: 'showVendorRates'
        },
        {
          label: 'VOS Rates',
          icon: 'el-icon-download',
          action: 'downloadVOSRate'
        },
        {
          label: 'Upload Rate',
          icon: 'el-icon-upload',
          action: 'uploadVendorRate'
        },
        {
          label: 'Remove',
          icon: 'el-icon-delete',
          action: 'removeActionConfirm'
        }
      ],
      userSearchTimeOut: null,
      amReady: false,
      module: {
        ...module
      },
      uploadVendorRateDialogVisibility: false,
      vendorToDeleteId: null,
      targetVendorId: null,
      deleteConfirmDialogVisible: false,
      vendorRatesDialogVisible: false,
      showPasswordField: false,
      selectedUsername: ' - ',
      selectedUserId: null,
      setProfitRateDialogVisible: false,
      viewUserTestsDialogVisible: false,
      setWorkingRatesDialogVisible: false,
      userSearch: '',
      currentPage: 1,
      pageChunkSize: 20,
      pageCount: 1,
      profilesList: [],
      editMode: false,
      dialogVisible: false,
      recordsCounter: 0,
      dataToBind: null,
      rowToEdit: null,
    };
  },

  props : {
    
      accManagerId: {
      required: true
    },
  },
  beforeMount() {
    
    this.currentPage = parseInt(this.$route.params.listPage)
    this.getEntityListData(this.currentPage)
  },
  beforeDestroy() {
  },
  methods: {
    assignVendorsToCarierRelationManager(params) {
      
        let data = {
            user_id: params.userId,
        account_manager_id : params.accountManagerId
      }
        //   debugger
      if (params.value) {
        data.action = 'assign';
        this.assign({data})
      } else {
        data.action = 'unAssign';
        this.assign({data})
      }
    },
    filterOptionsUpdated(inputField) {
      let val = inputField.field.field_value
      this.selectedFilterOption = val
      $vue.nextTick(() => {
        this.getEntityListData(1);
      })
    },
    
    updateDataTableField(customParams, newValue, afterSave, fieldName) {
      let data = {}
      data[fieldName] = newValue

      let apiParams = {
        id: customParams.id,
        data
      }
    
      this.updateEntity(apiParams).then(r => {
        let index = customParams.scope.$index
        customParams.scope.row[fieldName] = newValue
        afterSave()
        if (fieldName == 'balance') {
          let dateObj = new Date();
          let month = dateObj.getUTCMonth() + 1; //months from 1-12
          if (month < 10) month = "0" + month

          let day = dateObj.getUTCDate();
          if (day < 10) day = "0" + day

          let year = dateObj.getUTCFullYear();
          let seconds = dateObj.getUTCSeconds();
          let minutes = dateObj.getUTCMinutes();
          let hour = dateObj.getUTCHours();
          customParams.scope.row.last_balance_updated = year + "-" + month + "-" + day + ' ' + hour + ':' + minutes + ':' + seconds;
        }
      })
    },
    getEntityListData(page) {
      this.getEntityList({
        page: page,
        search: this.userSearch,
        filterOption: this.selectedFilterOption,
        showOnlyHasUnconnected: this.showOnlyHasUnconnected,
        listAllOption: this.listAllOption,
        customerUserId:this.accManagerId.id
      }).then(response => {
        this.buildAgGridData(response)
      })
      this.currentPage = page
    },
    buildAgGridData(response) {
      this.rowData = []
      $vue.nextTick(() => {
        this.rowData = response.rows;
        this.recordsCounter = response.count;
        this.amReady = true
      })
    },
    userSearchUpdated(field) {
      let val = field.field.field_value
      this.userSearch = val
      clearTimeout(this.userSearchTimeOut)
      this.userSearchTimeOut = setTimeout(() => {
        this.getEntityListData(1) //this.agGrid.gridApi.setQuickFilter(val);
      }, 200)
    },
    emptyOrNull(val) {
      return !val || val == ''
    },
    tableRowClassName({row, rowIndex}) {
      if (row.error_in_cdr_info == 'A') {
        return 'app-bg-red-low-alfa'
      }
      if (this.emptyOrNull(row.cdr_account_link) || this.emptyOrNull(row.cdr_account_username) || this.emptyOrNull(row.cdr_account_password)) {
        return 'app-bg-gold-low-alfa';
      }
      return '';
    },
    ...$mapActions('voip-vendor-api', {
      getEntityList: 'listToAssign',
      downloadVosRateAction: 'downloadVosRate',
      updateEntity: 'update',
      exportVendors: 'exportVendors',
      assign : 'assign'
    }),
    downloadVOSRate(params) {
      this.downloadVosRateAction({id: params.data.id})
    },
    afterUploadCallback() {
      this.uploadVendorRateDialogVisibility = false
      // this.rowData[this.rowToEdit].current_rates_counter = -1
      this.refreshGrid();
    },
    uploadVendorRate(params) {
      this.uploadVendorRateDialogVisibility = true
      this.targetVendorId = params.data.id
      this.rowToEdit = params.rowIndex
    },
    removeActionConfirm(params) {
      this.deleteConfirmDialogVisible = true
      this.vendorToDeleteId = params.data.id
      this.rowToEdit = params.rowIndex;
    },
    showVendorRates(params) {
      this.targetVendorId = params.data.id
      this.vendorRatesDialogVisible = true
    },
    downloadRateFile(params) {
      let url = process.env.VUE_APP_VOIP_GENERAL_BACKEND_SERVICE_URL + '/storage/' + params.data.file_name
      window.open(url, '_blank');
    },
    scrollToTop() {
      document.body.scrollTop = 0;
      document.getElementById('content-main-container').scrollTop = 0;
    },
    getPagesCount() {
      return Math.ceil(this.recordsCounter / this.pageChunkSize)
    },
    navigateToPage(page) {
      this.getEntityListData(page)
    },
    refreshGrid() {
      this.navigateToPage(this.currentPage)
    },
    afterEdit(updatedData) {
      $vue.set(this.rowData, this.rowToEdit, updatedData)
      this.dialogVisible = false;
      this.refreshGrid();
    },
    afterCreateProfitPercent() {
      this.setProfitRateDialogVisible = false
    },
    afterCreate(newEntity) {
      this.rowData.push(newEntity);
      this.dialogVisible = false;
      this.refreshGrid();
    },
    createAction(params) {
      this.showPasswordField = true;
      this.dialogVisible = true;
      this.editMode = false;
      this.dataToBind = null;
      this.rowToEdit = null;
      // this.$router.push({ name: 'esb-individual-teacher-view', params: { teacherId: params.data.id}})
    },
    editAction(params) {
      this.showPasswordField = false;
      this.editMode = true;
      this.dataToBind = params.data;
      this.rowToEdit = params.rowIndex;
      this.dialogVisible = true;
      // this.$router.push({ name: 'esb-individual-teacher-view', params: { teacherId: params.data.id}})
    },
    removeAction(params) {
      this.$store.dispatch(this.module.info.name + '-api/remove', {id: this.vendorToDeleteId}).then(response => {
        this.rowData.splice(this.rowToEdit, 1);
        this.refreshGrid();
        this.rowsCounter -= 1;
        this.deleteConfirmDialogVisible = false
        notify({
          type: 'success',
          title: this.$ml.get('deleted'),
        });
      })
    },
    actionsHandler(command, params) {
      this[command](params)
    }
  }
}
</script>
